import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BallerzToken, BallerzUserID } from "./Ballerz";

const endpoint = "https://app.ballerz.co.uk";

export const useGetRequest = (path) => {

  let ballerzToken = BallerzToken();
  let ballerzUserID = BallerzUserID();
  
  const [status, setStatus] = useState("idle");
  const [data, setData] = useState([]);

  const auth = {
    headers: {
      Authorization: `${ballerzToken}---${ballerzUserID}`
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      setStatus("fetching");
      try {
        const res = await axios.get(`${endpoint}/${path}`, auth);
        if (res) {
          setData(res.data);
        }
        setStatus("fetched");
      } catch(error){
        if(error.status == 401) {
          localStorage.removeItem("ballerz-user");
          window.location.href = "/login";
        } else {
          alert("There has been an error, please try again.");
        }
      }

    };

    fetchData();
  }, [path]);

  return { status, data };
};

export const sendPostRequest = async (path, params) => {  

  let ballerzToken = BallerzToken();
  let ballerzUserID = BallerzUserID();  

  const auth = {
    headers: {
      Authorization: `${ballerzToken}---${ballerzUserID}`
    },
  };

  const res = await axios.post(`${endpoint}/${path}`, params, auth);

  return res.data;
};